import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import MyButton from "../../util/MyButton";

// Redux
import { connect } from "react-redux";
import { editUserDetails } from "../../redux/actions/userActions";

// MUI imports
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";

// Icons
import EditIcon from "@material-ui/icons/Edit";

const styles = (theme) => ({
  ...theme.spreadThis,
  button: {
    float: "right",
  },
});

class EditDetails extends Component {
  state = {
    heightFt: "",
    heightIn: "",
    weight: "",
    open: false,
  };
  mapUserDetailsToState = (credentials) => {
    this.setState({
      heightFt: credentials.height ? parseInt(credentials.height / 12) : "",
      heightIn: credentials.height ? parseInt(credentials.height % 12) : "",
      weight: credentials.weight ? credentials.weight : "",
    });
  };
  handleOpen = () => {
    this.setState({ open: true });
    //this.mapUserDetailsToState(this.props.credentials);
    this.mapUserDetailsToState(this.props.user.userProfile);
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  componentDidMount() {
    // const { credentials } = this.props;
    const { userProfile } = this.props.user;
    // this.mapUserDetailsToState(credentials);
    this.mapUserDetailsToState(userProfile);
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  handleSubmit = () => {
    var heightConverted =
      parseInt(this.state.heightFt) * 12 + parseInt(this.state.heightIn);

    const userDetails = {
      height: heightConverted,
      weight: parseInt(this.state.weight),
      // age: this.props.credentials.age,
      age: this.props.user.userProfile.age,
      // addedDetails: this.props.credentials.addedDetails,
      addedDetails: this.props.user.userProfile.addedDetails,
    };
    this.props.editUserDetails(userDetails);
    this.handleClose();
  };
  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <MyButton
          tip="Edit Details"
          onClick={this.handleOpen}
          btnClassName={classes.button}
        >
          <EditIcon color="primary" />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Edit your details</DialogTitle>
          <DialogContent>
            <form>
              <Grid container spacing={2}>
                <Grid item>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    name="heightFt"
                    label="Ft"
                    type="text"
                    className={classes.textField}
                    value={this.state.heightFt}
                    onChange={this.handleChange}
                    autoFocus
                    fullWidth
                  />
                </Grid>
                <Grid item>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    name="heightIn"
                    label="Inches"
                    type="text"
                    className={classes.textField}
                    value={this.state.heightIn}
                    onChange={this.handleChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
              <TextField
                variant="outlined"
                margin="dense"
                name="weight"
                label="Weight (lbs)"
                type="text"
                className={classes.textField}
                value={this.state.weight}
                onChange={this.handleChange}
                fullWidth
              />
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSubmit} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

EditDetails.propTypes = {
  editUserDetails: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  // credentials: state.user.credentials,
  user: state.user,
});

export default connect(mapStateToProps, { editUserDetails })(
  withStyles(styles)(EditDetails)
);
